<ng-container *ngFor="let item of [].constructor(rating)">
  <app-icon
    [iconName]="'star'"
    [fillPathColor]="'yellow'"
    [width]="size"
    [height]="'auto'"
  ></app-icon>
</ng-container>
